var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7568 9.99986C20.7568 15.5223 16.2793 19.9998 10.7569 19.9998C5.23454 19.9998 0.757037 15.5223 0.757037 9.99985C0.757038 4.47655 5.23454 -4.5226e-05 10.7569 -4.47432e-05C16.2793 -4.42605e-05 20.7568 4.47656 20.7568 9.99986ZM19.9648 9.99986C19.9648 4.92206 15.8338 0.791956 10.7569 0.791955C5.68004 0.791955 1.54904 4.92205 1.54904 9.99985C1.54904 15.0768 5.68004 19.2078 10.7569 19.2078C15.8338 19.2078 19.9648 15.0768 19.9648 9.99986ZM11.2132 5.68166L14.068 8.42485C14.32 8.66696 14.32 9.06026 14.068 9.30236C13.816 9.54445 13.4065 9.54445 13.1545 9.30236L11.4031 7.61846L11.4031 13.8789C11.4031 14.2218 11.1133 14.4999 10.7569 14.4999C10.4005 14.4999 10.1107 14.2218 10.1107 13.8789L10.1107 7.61845L8.35934 9.30235C8.10734 9.54445 7.69784 9.54445 7.44584 9.30235C7.19384 9.06025 7.19384 8.66695 7.44584 8.42485L10.3006 5.68165C10.4257 5.56015 10.5913 5.49985 10.7569 5.49985C10.9225 5.49985 11.0872 5.56016 11.2132 5.68166Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUpIcon);
export default __webpack_public_path__ + "static/media/moveUpIcon.49b2e295359a46e8289e6c9a3fbeee5b.svg";
export { ForwardRef as ReactComponent };